<template>
    
    <!-- <span v-if="menu.link !== '' && menu.link !== null">
        <v-list-item  >
            <v-list-item-icon >
                <v-icon v-if="menu.icone!==''" >{{menu.icone}}</v-icon>
            </v-list-item-icon>

            <v-list-item-content >
                <v-list-item-title> {{menu.label}}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </span> -->
    <!-- v-if="menu.link === '' || menu.link === null" -->
    <v-list-group  v-if="menu.submenu && (Object.entries(menu.submenu).length>0 || menu.submenu.length>0)"
        :value="false"
        :prepend-icon="menu.icone" 
        no-action           
        sub-group
    >
        <template v-slot:activator>
        <v-list-item-title >{{menu.label}}</v-list-item-title>
        </template>


        <item-menu-sub-dois v-for="m in menu.submenu" :key="m.id" :menu="m" />
					
    </v-list-group>
    <span v-else>
        
        <v-list-item  @click="goto(menu.link)" class="ml-5">
            
            <v-list-item-content >                
                <v-list-item-title>{{menu.label}}</v-list-item-title>
            </v-list-item-content>   
              <v-list-item-icon v-if="menu.icone!==''">
                <v-icon  >{{menu.icone}}</v-icon>
            </v-list-item-icon>        
        </v-list-item>
    </span>

    <!-- <li> 
         
        <router-link  v-if="menu.link !== '' && menu.link !== null" to="menu.link">
            <i v-if="menu.icone!==''  && menu.icone !== null" :class="menu.icone" ></i>
            <span class="nav-label">{{menu.label}}</span>
        </router-link>
        
        <template  v-else>
            <a href="#">
                <i v-if="menu.icone!==''" :class="menu.icone" ></i>
                <span class="nav-label">{{menu.label}}</span>
                <span class="fa arrow"></span>
            </a>
            <ul class="nav nav-second-level collapse" v-if="menu.submenu && menu.submenu.length>0">
                <li><a href="basic_gallery.html">Lightbox Gallery</a></li>
                <item-menu v-for="m in menu.submenu" :key="m.id" :menu="m" />
            </ul>            
        </template>
    </li> -->

</template>

<script>

export default {
    name:'item-menu-sub',
    // data(){
    //     return {
    //         submenuB: false
    //     }
    // },
    props: {
        menu: {}
    },
    methods: {
        goto(link){
            this.$router.push({path: link}).catch(()=>{});
        }
    //     changeMenu(label) {
    //         console.log("label", label);
    //     }
    }
}
</script>